module.exports = __webpack_public_path__ + "media/images/vendors/category2-a8fb0725d789235145635383a5410255.jpg";